import { useRouterState } from "@tanstack/react-router";

/**
 * True on a screen that wears the SHIPPED appearance — the design's default
 * palette and accent, in the device's own light/dark mode — instead of the
 * user's. A boolean select, so a subscriber re-renders only when the flag
 * flips, never on a navigation within either world.
 *
 * This is the line the user's appearance stops at. Sign-in, registration, the
 * password screens, the workspace picker and the create screen belong to no
 * one yet — no user, or no space whose preferences would apply — so they
 * declare `staticData: { standardAppearance: true }` (the `(auth)` layout
 * once for its whole group; the `(app)` lobby leaves each). Read from the
 * matched routes' static data, not a path list: a hardcoded list here would
 * silently miss every screen added after it, and a workspace slug is an
 * arbitrary first segment, so `/login` and `/sales/inbox` cannot be told apart
 * by shape. The default — no flag — is the user's own appearance, which is
 * what every in-workspace screen wants and what a bare route harness mounts.
 */
export function useHasStandardAppearance(): boolean {
  return useRouterState({
    select: (s) =>
      s.matches.some((match) => match.staticData.standardAppearance === true),
  });
}
